import * as calendar from '../calendar'
import { evnMap } from '../evn'
import { serviceOptionsMap } from '../options'

const validatePassword = (password) => {
  // Mindestens 8, höchstens 32 Zeichen. Muss einen Buchstaben, sowie eine Ziffer oder eines der folgenden Sonderzeichen enthalten: # ( ) [ ] { } ? ! $ % & / = * + ~ , . : < > @ € - _
  /* eslint-disable-next-line no-useless-escape */
  const validChars = /^[A-Za-z\d#\\\/\?\!\$\%\&\=\[\]\(\)\{\}\*\+\,\.\:\<\>\@\€\-\_\§\^]{8,32}$/g.test(password)
  const hasNumbers = /[0-9]/.test(password)
  const hasAlpha = /[A-Za-z]/.test(password)
  /* eslint-disable-next-line no-useless-escape */
  const hasSpecial = /[#\\\/\?\!\$\%\&\=\[\]\(\)\{\}\*\+\,\.\:\<\>\@\€\-\_]/.test(password)
  const sequence = /(0123|1234|2345|3456|4567|5678|6789|3210|4321|5432|6543|7654|8765|9876)/.test(password)
  const sameNumber = /(.)\1{3}/.test(password)

  return validChars && (hasNumbers || hasSpecial) && hasAlpha && !sequence && !sameNumber
}

const install = function (Vue, options = {}) {
  const $config = {
    brand: 'puremobile',
    calendar,
    evnMap,
    serviceOptionsMap,
    validation: {
      validatePassword
    },
    ...options
  }

  Vue.mixin({
    computed: {
      $config () {
        return $config
      }
    }
  })
}

export default {
  install
}
